import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 1 1 -.905 -13.249","key":"svg-0"}]]

const IconSearchFilled = createReactComponent('filled', 'search-filled', 'SearchFilled', __iconNode);

export default IconSearchFilled;